import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setRegisterCompleted } from '../../../../actions/associatesActions';
import { useTranslation } from 'react-i18next';
import Header from '../../../../components/Common/Header/Header';
import SuccessScreen from '../../../Common/SuccessScreen';
import ErrorScreen from '../../../Common/ErrorScreen';

const FinishKycOperateConcierge = ({ history }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const response = history?.location?.state?.response ?? null;

  const [errorMessage, setErrorMessage] = useState({
    title: '',
    description: '',
  });

  const userKycStatus = useSelector(
    (state) => state?.associates?.user?.kycStatus
  );

  useEffect(() => {
    if (!response) {
      history.push('/');
      return;
    }


    if (response instanceof Error) {
      setErrorMessage({
        title: t('kycErrorFinished.genericError.title'),
        description: t('kycErrorFinished.genericError.description'),
      });
      dispatch(setRegisterCompleted(true));
      return;
    }

    if (response.data && !response.data.success) {
      dispatch(setRegisterCompleted(true));

      const errors = response.data.errors || ['genericError']; 
      errors.forEach((error) => {
        const title = t(`kycError.${error}.title`);
        const description = t(`kycError.${error}.description`);
        setErrorMessage({ title, description });
      });
    }
  }, [response, dispatch, history, t]);

  useEffect(() => {
    if (userKycStatus === 'APPROVED' || userKycStatus === 'SEND') {
      window.location.href = '/';
    }
  }, [userKycStatus]);

  if (!response) {
    return null;
  }


  const success = response?.data?.success ?? false;

  return (
    <>
      {success ? (
        <>
          <Header showBack={false} />
          <SuccessScreen
            title={`${t('done')}!`}
            subtitle={t('kyc.successKyc')}
            onClick={() => (window.location.href = '/')}
          />
        </>
      ) : (
        <>
          <Header title={t('kycErrorFinished.validateIdentity')} hasBackground={true} />
          <ErrorScreen
            title={errorMessage.title}
            subtitle={errorMessage.description }
            buttonText={t('tryAgain')}
            path={'/kyc-start'}
            returnHome
          />
        </>
      )}
    </>
  );
};

export default FinishKycOperateConcierge;
